import { Component } from 'preact';
import { Text } from 'preact-i18n';

class ChildAgeSelect extends Component {
  constructor(props) {
    super(props);

    this.createAgeOptions = this.createAgeOptions.bind(this);
  }

  createAgeOptions() {
    return Array(18)
      .fill({})
      .map((_, index) => ({
        value: String(index),
        label_years_old_interval: <Text id='label.years_old_interval' plural={index} fields={{ years_old: index }} />,
      }));
  }

  render() {
    const { ages, onAgeChange } = this.props;
    const options = this.createAgeOptions();

    return (
      <div className="age-select">
        {ages.map((age, index) => {
          const key = `${age}-${index}`;
          return (
            <div className="age-select-item">
              <div className="age-select-inner-wrap">
                <label><Text id='label.child_age_index' fields={{ index: index + 1 }} /></label>
                <select key={key} value={age} onChange={e => onAgeChange(e, index)}>
                  {options.map(({ value, label_years_old_interval }) => (
                    <option key={value} value={value}>
                      {label_years_old_interval}
                    </option>
                  ))}
                </select>
                <div className="age-select-arrow" />
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

export default ChildAgeSelect;
